export default __webpack_public_path__ + "static/media/typebus.18f037a7.svg";